// extracted by mini-css-extract-plugin
export var component = "SidebarSignpost-module--component--10745";
export var fadePop = "SidebarSignpost-module--fade-pop--7bfc4";
export var growHeightIn = "SidebarSignpost-module--grow-height-in--7f1ca";
export var image = "SidebarSignpost-module--image--346dd";
export var imageTitleWrapper = "SidebarSignpost-module--imageTitleWrapper--0a636";
export var link = "SidebarSignpost-module--link--1757e";
export var linkText = "SidebarSignpost-module--linkText--58fe1";
export var withImage = "SidebarSignpost-module--withImage--30d3d";